import React from 'react';
import styled from 'styled-components/macro';
import 'react-quill/dist/quill.bubble.css';
import ReactQuill, { Quill } from 'react-quill';
import 'quill-mention';
import 'quill-mention/dist/quill.mention.css';
// import ImageCompress from 'quill-image-compress';
import CustomClipboardModule from './CustomClipboardModule';
import { apiList } from '../../../../../locales/apiList'
import { UseAxios } from 'utils/UseAxios';

// disable because it also get onPaste and paste compressed duplicate image
// Quill.register('modules/imageCompress', ImageCompress);
Quill.register('modules/clipboard', CustomClipboardModule);

export function CustomEditor(props) {
  const { inputTextChange, mentionList, emailList, replyMentionEmail, replyClick, setReplyClick, resetInput, setResetInput, oacl } = props;
  let text: string = '';
  let reactQuillRef: any;

    // Image upload function
    const uploadImage = async (requestBody: Array<{file: string; type: string; fileName: string}>) => {
      try {
        const uploadResult = await UseAxios(
          `${apiList.postAttachmentURL}${oacl}/attachment`, 
          'post', 
          requestBody, 
          false, 
          false
        );
        
        return uploadResult;
      } catch (error) {
        console.error('Image upload error:', error);
        return { error: true };
      }
    };

  React.useEffect(() => {
    if (replyMentionEmail && replyClick) {
      let myEditor = reactQuillRef.getEditor();
      const replyName = (Object.keys(emailList) as (keyof typeof emailList)[]).find((key) => {
        return emailList[key] === replyMentionEmail;
      });
      let replyID = 0;
      mentionList.forEach(mentionData => {
        if (mentionData.value === replyName) {
          replyID = mentionData.id;
        }
      });
      myEditor.getModule('mention').insertItem({ denotationChar: '@', id: replyID, value: replyName }, true);
      setReplyClick(false);
    }
  }, [replyClick]);

  React.useEffect(() => {
    if (resetInput) {
      let myEditor = reactQuillRef.getEditor();
      myEditor.deleteText(0,myEditor.getLength());
      setResetInput(false);
    }
  }, [resetInput]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
    ],
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      renderLoading: () => {
        return 'Loading...';
      },
      source: function(searchTerm, renderItem, mentionChar) {
        let values: any[] = [];
        if (mentionChar === '@') {
          values = mentionList;
        }
        if (searchTerm.length === 0) {
          renderItem(values, searchTerm);
        } else {
          const matches: any[] = [];
          for (let i = 0; i < values.length; i++)
            if (
              ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
            )
              matches.push(values[i]);
          renderItem(matches, searchTerm);
        }
      },
    },
    // imageCompress: {
    //   quality: 0.7,
    //   maxWidth: 1000,
    //   maxHeight: 1000,
    //   imageType: 'image/png',
    //   debug: false,
    //   suppressErrorLogging: true,
    // },
    clipboard: {
      uploadImage,
    },
  };
  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'mention',
  ];

  const handleProcedureContentChange = (content, delta, source, editor) => {
    inputTextChange(content);
  };

  return (
    <Wrapper>
      <ReactQuill
        ref={(el) => {
          reactQuillRef = el;
        }}
        theme='snow'
        modules={modules}
        formats={formats}
        defaultValue={text}
        onChange={handleProcedureContentChange}
      >
        <div className='editing-area' />
      </ReactQuill>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  margin: 5px 0;

  .editing-area {
    min-height: 70px;
    max-height: 120px;
    overflow-y: auto;
    position: static;
  }

  .ql-mention-list-container {
    width: 400px;
    min-width: 400px;
    border: 1px solid #F0F0F0;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 12px 0 rgba(30, 30, 30, 0.08);
    z-index: 9001;
    top: 55px !important;
    left: 75px !important;
    white-space: nowrap;
    overflow: hidden;
  }

  .ql-mention-list {
    list-style: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .ql-mention-list-item {
    cursor: pointer;
    height: 30px;
    line-height: 10px;
    font-size: 12px;
    padding: 10px;
    vertical-align: middle;
  }

  .ql-mention-list-item.selected {
    background-color: #D3E1EB;
    text-decoration: none;
  }

  .mention {
    height: 24px;
    width: 65px;
    border-radius: 6px;
    background-color: #D3E1EB;
    padding: 3px 0;
  }

  .mention > span {
    margin: 0 3px;
  }
`;
